import React from 'react'
import './button.css'

function FilledSquareButton({onClickHandler, name, size="large"}) {
    return (
        <button type="button" className={`filled filled-square-button ${size}`} onClick={onClickHandler}>{name}</button>
    )
}

export default FilledSquareButton